import React from "react";

import Searchbar from "../../utils/searchbar/Searchbar";
import SearchTranslationSection from "../../search/SearchTranslationSection";

class TranslationSectionSearch extends React.PureComponent {
	render() {
		return (
			<React.Fragment>
				<Searchbar
					placeholder={"Search translation sections"}
					component={SearchTranslationSection}
					searchEndpoint={"search/translation-section"}
					{...this.props}
					userType="admin"
					index="id"
					params={{ language: process.env.REACT_APP_LANGUAGE }}
				/>
			</React.Fragment>
		);
	}
}

export default TranslationSectionSearch;



// WEBPACK FOOTER //
// ./src/components/admin/translations/TranslationSectionSearch.js